import configs from './configs';
import MainService from './modules/services/main.service';
import { getFromSessionStorage } from './utils/utils';

export default class AppService {
  user = null;
  mainService = null;
  constructor() {
    this.mainService = new MainService();
    this.user = getFromSessionStorage('user', {});
  }

  listPrivileges = str_code => {
    return this.mainService.get(
      configs.auth_api_url + '/privileges/' + str_code,
      true,
    );
  };

  listPrivilegesReports = () => {
    return this.mainService.get(
      configs.auth_api_url + '/reports/privileges',
      true,
    );
  };

  listPrivilegesBuReports = () => {
    return this.mainService.get(
      configs.auth_api_url + '/bu-reports/privileges',
      true,
    );
  };
  getFile = (str_url, isStatic = false) => {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Authorization', sessionStorage.getItem('java-token'));
      headers.append('X-Custom-Header', 'value');
      if (configs.Apim_Key) {
        headers.append('Ocp-Apim-Subscription-Key', configs.Apim_Key);
      }

      fetch(
        (isStatic ? configs.file_api_static_url : configs.file_api_url) +
          `/documents/${str_url}`,
        {
          method: 'get',
          credentials: 'include',
          headers,
        },
      )
        .then(async res => {
          return res.blob();
        })
        .then(blob => {
          const url = URL.createObjectURL(blob);
          resolve(url);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
          reject(error);
        });
    });
  };

  createDownloadTicket = (data = {}) => {
    return this.mainService.post(
      configs.file_api_url + '/create-download-ticket',
      data,
    );
  };

  getStreamDocuments = str_url => {
    return new Promise((resolve, reject) => {
      const headers = new Headers();
      headers.append('Authorization', sessionStorage.getItem('java-token'));
      headers.append('X-Custom-Header', 'value');
      headers.append('Content-Type', 'application/octet-stream');

      fetch(configs.file_api_url + `/stream-documents/${str_url}`, {
        method: 'get',
        credentials: 'include',
        headers,
      })
        .then(async res => {
          console.log(res, 'application/octet-stream');
          return res.blob();
        })
        .then(blob => {
          const url = URL.createObjectURL(blob);
          resolve(url);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
          reject(error);
        });
    });
  };

  uploadFile = obj_file => {
    return this.mainService.post(
      configs.file_api_url + '/base64-documents',
      obj_file,
    );
  };

  uploadSample = (name, file) => {
    let data = new FormData();
    data.append('file', file);
    data.append('name', name);
    return this.mainService.uploadFile(configs.file_api_url + '/samples', data);
  };

  uploadSampleOkNok = (uuid_round, file) => {
    let data = new FormData();
    data.append('file', file);
    data.append('uuid_round', uuid_round);
    return this.mainService.uploadFile(
      configs.file_api_url + '/ok-nok-samples',
      data,
    );
  };
  uploadCompetitionTaster = (uuid_round, file) => {
    let data = new FormData();
    data.append('file', file);
    data.append('uuid_round', uuid_round);
    return this.mainService.uploadFile(
      configs.file_api_url + '/competitors',
      data,
    );
  };

  login = obj_login => {
    return this.mainService.post(
      configs.auth_api_url + '/logons',
      obj_login,
      false,
    );
  };

  NonAbiLogin = obj_login => {
    return this.mainService.post(
      configs.auth_api_url + '/non-abi-logons',
      obj_login,
      false,
    );
  };
  getUserCompetitionRound = uuid_round => {
    return this.mainService.get(
      `${configs.auth_api_url}/competition-rounds/${uuid_round}`,
    );
  };

  CompetitionLogin = obj_login => {
    return this.mainService.post(
      configs.auth_api_url + '/competition-logons',
      obj_login,
      false,
    );
  };

  checkCookies = () => {
    return this.mainService.post(configs.auth_api_url + '/tokens/validation', {
      str_token: this.user.str_token,
    });
  };

  updateDocument = obj_document => {
    return this.mainService.post(
      configs.file_api_url + '/documents',
      obj_document,
    );
  };

  removeDocument = uuid_document => {
    return this.mainService.patch(
      configs.file_api_url + `/documents/${uuid_document}`,
    );
  };

  getFileBase64 = document => {
    return this.mainService.get(
      configs.file_api_url + `/base64-documents/${document}`,
    );
  };

  validateVersion = () => {
    // Version/configuration discovery runs before authentication. A 401 here
    // must not be treated as an expired user session, otherwise a failed KC
    // auto-login causes MainService to reload the whole page.
    return this.mainService.get(configs.auth_api_url + '/web/versions/latest', {
      skipSessionCheck: true,
    });
  };

  // java
  loginJava = obj_login => {
    return this.mainService.post(
      configs.auth_api_url + '/logons',
      obj_login,
      false,
    );
  };
  NonAbiLoginJava = obj_login => {
    return this.mainService.post(
      configs.auth_api_url + '/non-abi-logons',
      obj_login,
      false,
    );
  };
  CompetitionLoginJava = obj_login => {
    return this.mainService.post(
      configs.auth_api_url + '/competition-logons',
      obj_login,
      false,
    );
  };
}
